import {Component} from '@angular/core';

@Component({
    selector: 'form-holder',
    templateUrl: './form-holder.component.html'
})
export class FormHolderComponent {

}
